/**
 * Mercure topic and notification utilities.
 */

/**
 * Resolve topic pattern with params.
 * resolveTopic("/api/users/:userId/permissions", { userId: 5 })
 * → "/api/users/5/permissions"
 */
export function resolveTopic(pattern: string, params: Record<string, unknown>): string {
  if (!pattern || !params) return pattern;
  return pattern.replace(/:(\w+)/g, (_, key) => {
    return params[key] !== undefined ? String(params[key]) : `:${key}`;
  });
}

/**
 * Parse API Platform notification to app format.
 */
export function parseNotification(data: Record<string, unknown>) {
  if (!data) return null;

  return {
    id: data.id || data["@id"],
    title: data.title,
    message: data.message,
    type: data.type || "info",
    timestamp: data.dateCreation,
    read: data.readAt !== null,
  };
}

/**
 * Parse API Platform document to app format.
 */
export function parseDocument(data: Record<string, unknown>) {
  if (!data) return null;

  return {
    id: data.id || data["@id"],
    title: data.title,
    type: data.type,
    filename: data.filename,
    mimeType: data.mimeType,
    size: data.size,
    dateCreation: data.dateCreation,
  };
}
